import React from "react";

import { useTranslation } from "react-i18next";

import { SportStatisticsTypeEnum } from "@data-types/analytics-tracker/SportsStatisticsInteractionTypeEnum";
import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import { EventContentTab } from "@features/offer/shared/event";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { analyticsTracker } from "@utils/analytics";
import { observer } from "mobx-react";

export const EventInsightsButton = observer(
	function EventInsightsButton(props: {
		store: EventViewStore | AdditionalOfferViewStore;
	}) {
		const { t } = useTranslation();

		const { sportStatisticsStore } = props.store;

		return (
			<EventContentTab
				textContent={t("EVENT.HEADER.EVENT_INSIGHTS")}
				isActive={
					props.store.displayStatisticsGroup ===
					StatisticsGroups.EventInsights
				}
				disabled={sportStatisticsStore.isFetching}
				onClick={() => {
					if (
						props.store.displayStatisticsGroup !==
						StatisticsGroups.EventInsights
					) {
						analyticsTracker.trackSportStatisticsInteractionTracking(
							SportStatisticsTypeEnum.LiveStatisticsVisit
						);
						props.store.setDisplayStatisticsGroup(
							StatisticsGroups.EventInsights
						);
					}
				}}
				// hasNewTag
			/>
		);
	}
);
